import { Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[igoStopPropagation]'
})
export class StopPropagationDirective {

  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    event.stopPropagation();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/stop-propagation/stop-propagation.directive.ts